const initialState = {
  showLoading: false,
}

const componentName = 'loading'

const ACTION_TYPES = {
  SHOW: componentName + 'SHOW',
  HIDE: componentName + 'HIDE',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'loading_show':
      return {
        ...state,
        showLoading: true,
      }
    case 'loading_hide':
      return {
        ...state,
        showLoading: false,
      }
    default:
      return state
  }
}

export const showLoading = () => ({
  type: ACTION_TYPES.SHOW,
})
export const hideLoading = () => ({
  type: ACTION_TYPES.HIDE,
})

export default reducer
